import React from 'react';
import ProjectSidebarComponent from './ProjectSidebarComponent';
import { PageHeader } from '../../components';

const MultiEffectEvaporatorMeeAgitatedThinFilmDryerAtfd: React.FC = () => {
  return (
    <>
      <PageHeader title="Multi Effect Evaporator (MEE) / Agitated Thin Film Dryer (ATFD)" breadcrumbs={[{ label: "Projects", path: "/projects" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-3.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-1.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Multi Effect Evaporator (MEE) / Agitated Thin Film Dryer (ATFD)</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Multi Effect Evaporators (MEE) and Agitated Thin Film Dryers (ATFD) are critical components of Zero Liquid Discharge (ZLD) systems. These technologies concentrate and convert high-TDS industrial effluent into solids or minimal residue, making them indispensable in sectors where regulatory norms mandate zero discharge.</p>
              <p>At Wasser Technochem (India) Ltd., we design and execute energy-efficient MEE and ATFD systems with proven performance across India's most water-stressed and pollution-sensitive industries.</p>

              <h3 className="mb-4">Applications</h3>
              <p><i className="fa fa-industry text-primary me-2"></i>Textile & dyeing industries (high salt and color loads)</p>
              <p><i className="fa fa-pills text-primary me-2"></i>Pharmaceuticals & bulk drugs (organic-heavy wastewater)</p>
              <p><i className="fa fa-flask text-primary me-2"></i>Chemical manufacturing units (residual solvents, salts)</p>
              <p><i className="fa fa-seedling text-primary me-2"></i>Pesticide, agrochemical & specialty chemical plants</p>
              <p><i className="fa fa-utensils text-primary me-2"></i>Food, dairy, and distillery effluent treatment</p>
              <p><i className="fa fa-recycle text-primary me-2"></i>Integration with multi-stage RO for ZLD</p>

              <h3 className="mb-4">Our Capabilities</h3>
              <p>WTIL delivers custom-engineered thermal evaporation systems suited for a wide range of feed characteristics and volume loads.</p>
              
              <h4 className="mb-3 text-success"><i className="fa fa-check-circle me-2"></i>Multi Effect Evaporators (MEE)</h4>
              <p><i className="fa fa-layer-group text-primary me-2"></i>Multiple stages (2/3/4/5 effects) for steam efficiency</p>
              <p><i className="fa fa-arrow-right text-primary me-2"></i>Forward-feed, backward-feed, or mixed-feed configurations</p>
              <p><i className="fa fa-water text-primary me-2"></i>Falling film or forced circulation based on fluid type</p>
              <p><i className="fa fa-compress text-primary me-2"></i>Vapor recompression systems (TVR/MVR) for energy savings</p>
              <p><i className="fa fa-tachometer-alt text-primary me-2"></i>Capacity: 5 KLD to 500+ KLD</p>

              <h4 className="mb-3 text-success"><i className="fa fa-check-circle me-2"></i>Agitated Thin Film Dryer (ATFD)</h4>
              <p><i className="fa fa-cog text-primary me-2"></i>Final stage in ZLD to dry concentrated brine into powder/crystals</p>
              <p><i className="fa fa-droplet text-primary me-2"></i>Handles high-viscosity, high-salt sludge</p>
              <p><i className="fa fa-sync-alt text-primary me-2"></i>Rotary agitator ensures thin film and uniform drying</p>
              <p><i className="fa fa-fire text-primary me-2"></i>Steam or electrical heating</p>
              <p><i className="fa fa-percentage text-primary me-2"></i>Output TDS: &gt;95% solid concentration</p>

              <h3 className="mb-4">Benefits</h3>
              <p><i className="fa fa-check-circle text-success me-2"></i>Reduces wastewater volume by up to 95–98%</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Converts hazardous streams into disposable solids</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>High energy efficiency with TVR/MVR integration</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Ensures long-term ZLD compliance and environmental safety</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Compatible with upstream RO and ETP units</p>

              <h3 className="mb-4">Why WTIL?</h3>
              <p><i className="fa fa-star text-warning me-2"></i>Complete ZLD solution from RO → MEE → ATFD</p>
              <p><i className="fa fa-star text-warning me-2"></i>In-house thermal and mechanical design team</p>
              <p><i className="fa fa-star text-warning me-2"></i>25+ successful ZLD implementations across textile, pharma, and chemicals</p>
              <p className="mb-5"><i className="fa fa-star text-warning me-2"></i>Trusted partners for industries in Rajasthan, Gujarat, Tamil Nadu, and MP</p>
            </div>

            <div className="col-lg-4">
              <ProjectSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default MultiEffectEvaporatorMeeAgitatedThinFilmDryerAtfd;
